import { Quote, Star } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/site/Primitives";
import { TESTIMONIALS } from "@/data/site";

export const Testimonials = () => {
  return (
    <section id="stimmen" className="relative py-24 lg:py-36 bg-cream-soft">
      <div className="mx-auto max-w-6xl px-6 lg:px-10">
        <Reveal>
          <div className="text-center max-w-2xl mx-auto">
            <Eyebrow className="justify-center">Kundenstimmen</Eyebrow>
            <h2 className="mt-6 font-serif font-light tracking-tight text-charcoal text-4xl sm:text-5xl leading-tight">
              Was meine Patientinnen & Patienten sagen
            </h2>
            <div className="mt-7 inline-flex items-center gap-3 rounded-full border border-gold/30 bg-cream px-6 py-3">
              <span className="flex items-center gap-0.5">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={18} className="fill-gold text-gold" />
                ))}
              </span>
              <span className="text-charcoal font-medium">5,0</span>
              <span className="h-4 w-px bg-gold/40" />
              <span className="text-sm text-charcoal-soft">Google &amp; Groupon Bewertungen</span>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-14 columns-1 md:columns-2 lg:columns-3 gap-6 [column-fill:_balance]">
            {TESTIMONIALS.map((t, i) => (
              <figure
                key={i}
                data-testid={`testimonial-${i}`}
                className="mb-6 break-inside-avoid bg-cream rounded-[1.5rem] border border-gold/20 p-6 lg:p-7"
              >
                <div className="flex items-center justify-between">
                  <Quote size={24} strokeWidth={1} className="text-gold" />
                  <span className="flex items-center gap-0.5">
                    {[...Array(5)].map((_, s) => (
                      <Star key={s} size={13} className="fill-gold text-gold" />
                    ))}
                  </span>
                </div>
                <blockquote className="mt-4 text-charcoal leading-relaxed text-[15px] font-light">
                  {t.quote}
                </blockquote>
                <figcaption className="mt-5 flex items-center gap-3 pt-4 border-t border-gold/15">
                  <span className="h-10 w-10 shrink-0 rounded-full bg-rose flex items-center justify-center font-serif text-charcoal">
                    {t.author.charAt(0)}
                  </span>
                  <span className="min-w-0">
                    <span className="block text-sm text-charcoal font-medium truncate">{t.author}</span>
                    <span className="block text-xs text-charcoal-muted">{t.detail} · via {t.source}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
